import { render, staticRenderFns } from "./addChetou.vue?vue&type=template&id=5f1c774e&scoped=true&"
import script from "./addChetou.vue?vue&type=script&lang=js&"
export * from "./addChetou.vue?vue&type=script&lang=js&"
import style0 from "./addChetou.vue?vue&type=style&index=0&id=5f1c774e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1c774e",
  null
  
)

export default component.exports